export const connectionErrorsMap = {
    ErrorMappingIdPositive: 'Failed to add connection: mapping ID issues',
    ErrorMappingIdConflict: 'Failed to add connection: mapping ID conflicts',
    ErrorLinkSelfLoop: 'Failed to add connection: self-loops found',
    ErrorNotFoundNode: 'Failed to add connection: node not found',
    ErrorNotFoundLink: 'Failed to add connection: connection not found',
    ErrorNodeForLinkDeleted: 'Failed to add connection: nodes for connection deleted',
    ErrorNodeForLinkInsertDeleted: 'Failed to add connection: nodes for link insertions deleted',
    ErrorLinkInsertImpossible: 'Failed to add connection: link insertion impossible',
    ErrorLinkUnique: 'Failed to add connection: unique connection issues found',
    ErrorLinkDuplicate: 'Failed to add connection: duplicate connection',
    ErrorLinkRequired: 'Failed to add connection: required connection is missing',
};
//# sourceMappingURL=index.js.map